// Shown on both the landing composer and the "new chat" composer.
const SAMPLE_PROMPTS: string[] = [
  'What are the 5 most important takeaways from the surveys, focusing in particular in areas where the stakeholders disagreed?',
  'What are some good visualizations from the EOAA school reports to be highlighted in the district report?',
  'Where are the major outliers in PSS via CTE performance across demographics/schools in this district?',
  'What quotes in the focus group reports for this district should be highlighted in the district report?',
];

export { SAMPLE_PROMPTS };
